import React, { useState } from 'react';
import styled from 'styled-components';
import HelpCenter from './HelpCenter';
import UserAgreement from './UserAgreement';
import CoinAccuracyLimit from './CoinsAndCurrencyLimit';
import SupportHelp from './SupportHelp';
import FeeComponent from './FeeHelp';
import GoogleAuthenticatorComponent from './GoogleAuthenticator';
import FAQComponent from './FAQ';
import RegistrationAndLogin from './RegisterAndLogin';
import CryptocurrencyInfo from './CryptCurrencyInfo';
import PrivacyPolicyHelp from './PrivacyPolicyHelp';
import HGSwap from './HGSwapPolicy';
import TermsOfService from './TermsofServiceHelp';
import ProvidersHelp from './ProvidersHelp';
import { MdKeyboardArrowRight } from "react-icons/md";

// Styled components
const HelpCenterContainer = styled.div`
  display: flex;
  color: #ffffff;
  gap: 10px;
  align-items: flex-start;
position:relative;

@media(max-width:1100px){
  flex-direction:column;
  }
`;

const SideContent = styled.div`
  width: 300px;
  padding: 10px;
  background-color: rgb(50, 55, 56);
  border-radius: 10px;  
  align-self: flex-start;

  @media (max-width: 1100px) {
    width: 100%;
    display: flex;
    overflow-x: scroll;  
    padding: 5px;
    gap:10px;
  }

`;


const SideContentItem = styled.div`
  padding: 10px 0 10px 20px;
  cursor: pointer;
  font-size: 15px;
  font-weight: bold;
  display: flex;
  gap: 5px;
  color: ${props => (props.active ? 'white' : '#B3B3B3')};
  background-color: ${props => (props.active ? '#3A4142' : 'transparent')};
  border-radius: ${props => (props.active ? '10px' : '0')};

  @media (max-width: 1100px) {
    width: auto;  
    max-width:200px;
    flex-shrink: 0; 
    padding:10px;
  }

  @media (max-width: 545px) {
    font-size: 12px;
    align-items: center;
  }
`;


const MainContent = styled.div`
  flex: 1;
  min-height: 100%;
`;

const ResponsiveSelect = styled.div`
  display: none;
   button {
    width: 250px; 
    height: 7vh;  
    color: red;  
    background: #2B2E35;  
    border: none;  
    border-radius: 20px; 
    cursor: pointer; 
    font-size: 1rem; 
    transition: background 0.3s;  
    font-weight: 600;
    padding: 10px;

  }

  @media (max-width: 968px) {
    display: block;  
  }
`;
 
const ProvablyFairSelect = styled.div`
  display: none;
  border-radius: 1.25rem;
  padding: 0.125rem 0.375rem;
  background-color: rgb(23, 24, 27);
  box-shadow: rgba(0, 0, 0, 0.14) 0px 0px 8px 0px;
  height: auto;
  max-height: 16.25rem;
  box-sizing: border-box;
  overflow-y: auto;
  z-index: 9999;
  touch-action: pan-y;
  overscroll-behavior: contain;
`;

const List = styled.div`
  margin-top: 0;
  color: ${props => props.active ? '#ffffff' : 'rgba(245, 246, 247, 0.6)'};
  font-weight: bold;
  height: 2.25rem;
  border: ${props => props.active ? '1px solid rgba(91, 174, 28, 1)' : ''};
  font-size: 0.875rem;
  display: flex;
  align-items: center; 
  position: relative;
  padding: 0 0.625rem;
  margin: 0.25rem 0;
  border-radius: 1.0625rem;
  cursor: pointer;
  white-space: nowrap; 
  background-color: transparent; 

  &:hover {
    border-color: rgba(91, 174, 28, 1);  
  }
`;

const ResponsiveWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

const ProvablyFair = () => {
    const [activeListItem, setActiveListItem] = useState('Provably fair');
    const [activeSection, setActiveSection] = useState('Provably fair');
    const [isSelectOpen, setSelectOpen] = useState(false);  

    const sideContentItems = [
      { name: 'Provably fair', component: HelpCenter, img: "/assets/bcimages/provablyfair/svgexport-1.svg" },
      { name: 'User Agreement', component: UserAgreement, img: "/assets/bcimages/provablyfair/svgexport-2.svg" },
      { name: 'Coin Accuracy Limit', component: CoinAccuracyLimit, img: "/assets/bcimages/provablyfair/svgexport-3.svg" },
      { name: 'Support', component: SupportHelp, img: "/assets/bcimages/provablyfair/svgexport-4.svg" },
      { name: 'Fee', component: FeeComponent, img: "/assets/bcimages/provablyfair/svgexport-5.svg" },
      { name: 'Google Authenticator', component: GoogleAuthenticatorComponent, img: "/assets/bcimages/provablyfair/svgexport-6.svg" },
      { name: 'FAQ', component: FAQComponent, img: "/assets/bcimages/provablyfair/svgexport-7.svg" },
      { name: 'Cryptocurrency', component: CryptocurrencyInfo, img: "/assets/bcimages/provablyfair/svgexport-8.svg" },
      { name: 'Privacy Policy', component: PrivacyPolicyHelp, img: "/assets/bcimages/provablyfair/svgexport-9.svg" },
      { name: 'Registration and Lo...', component: RegistrationAndLogin, img: "/assets/bcimages/provablyfair/svgexport-10.svg" },
      { name: 'Swap Policy', component: HGSwap, img: "/assets/bcimages/provablyfair/svgexport-11.svg" },
      { name: 'Terms of Service', component: TermsOfService, img: "/assets/bcimages/provablyfair/svgexport-12.svg" },
      { name: 'Providers', component: ProvidersHelp, img: "/assets/bcimages/provablyfair/svgexport-13.svg" }
  ];
  
    const ActiveComponent = sideContentItems.find(item => item.name === activeSection)?.component || (() => null);

    const handleListItemClick = (item) => {
        setActiveListItem(item);
        setActiveSection(item);
        setSelectOpen(false); 
    };

    const handleButtonClick = () => {
        setSelectOpen(!isSelectOpen);  
    };

    return (
        <div style={{ marginTop: '25px'}}>
            <div style={{ fontSize: '16px', fontWeight: 'bold', margin: '10px 0', color: '', display: 'flex', gap: '10px', alignContent: 'center', alignItems: 'center' }}>
                <img style={{height:'20px', width:'20px'}} src='/assets/images/taraju.png' />
                <div>Help Center</div>
            </div>

            <HelpCenterContainer style={{marginTop: '30px'}}>
                <SideContent>
                    {sideContentItems.map(item => (
                        <SideContentItem
                            key={item.name}
                            active={activeSection === item.name}
                            onClick={() => setActiveSection(item.name)}
                        >
                          <img className="side-content-item-img" src={item.img}/>
                            {item.name}
                        </SideContentItem>
                    ))}
                </SideContent>

                <ResponsiveWrapper>
                    {/* <ResponsiveSelect>
                        <button 
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                            onClick={handleButtonClick}
                        >
                            {activeListItem}
                            <MdKeyboardArrowRight  style={{ transform: isSelectOpen ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }}  fontSize={"25px"}/>
                        </button>
                    </ResponsiveSelect> */}

                    {isSelectOpen && (  
                        <ProvablyFairSelect>
                            {sideContentItems.map(item => (
                                <List 
                                    key={item.name}
                                    active={activeListItem === item.name}
                                    onClick={() => handleListItemClick(item.name)}
                                >
                                    {item.name}
                                </List>
                            ))}
                        </ProvablyFairSelect>
                    )}

                    <MainContent>
                        <ActiveComponent />
                    </MainContent>
                </ResponsiveWrapper>
                
            </HelpCenterContainer>

        </div>
    );
};

export default ProvablyFair;
